<interactive-toast [key]="'login'"></interactive-toast>
@if (showError()) {
<div class="flex gap-2 justify-center items-center text-[#E73A3A] mt-[32px]">
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.84392 14.156C2.07984 13.4181 1.47038 12.5353 1.05111 11.5593C0.631834 10.5832 0.411144 9.53348 0.401913 8.47125C0.392683 7.40901 0.595096 6.35558 0.997344 5.37241C1.39959 4.38924 1.99362 3.49602 2.74476 2.74488C3.4959 1.99374 4.38911 1.39971 5.37228 0.997466C6.35546 0.595219 7.40889 0.392805 8.47113 0.402035C9.53336 0.411266 10.5831 0.631956 11.5592 1.05123C12.5352 1.4705 13.4179 2.07996 14.1559 2.84404C15.6132 4.35286 16.4195 6.37367 16.4013 8.47125C16.3831 10.5688 15.5417 12.5753 14.0585 14.0586C12.5752 15.5419 10.5687 16.3832 8.47113 16.4014C6.37355 16.4197 4.35273 15.6133 2.84392 14.156ZM13.0279 13.028C14.2288 11.8271 14.9035 10.1984 14.9035 8.50004C14.9035 6.80171 14.2288 5.17294 13.0279 3.97204C11.827 2.77114 10.1982 2.09648 8.49992 2.09648C6.80159 2.09648 5.17282 2.77114 3.97192 3.97204C2.77102 5.17294 2.09636 6.80171 2.09636 8.50004C2.09636 10.1984 2.77102 11.8271 3.97192 13.028C5.17282 14.2289 6.80159 14.9036 8.49992 14.9036C10.1982 14.9036 11.827 14.2289 13.0279 13.028ZM7.69992 4.50004H9.29992V9.30004H7.69992V4.50004ZM7.69992 10.9H9.29992V12.5H7.69992V10.9Z"
      fill="currentColor"
    />
  </svg>
  <p class="font-lato font-normal text-sm xlplus:text-base">
    {{showError()}}
  </p>
</div>
}
<form [formGroup]="loginForm" (ngSubmit)="submitForm()">
  <div [ngClass]="showError() ? 'mt-[12px]' : 'mt-[32px]'">
    <div class="flex flex-col gap-2 mx-[12px]">
      <label class="font-lato font-bold text-sm xlplus:text-base">Email</label>
      <input
        type="email"
        class="!text-sm xlplus:!text-base placeholder:!text-sm xlplus:placeholder:!text-base placeholder:!text-gray-400"
        placeholder="Enter your email"
        [ngClass]="
          (failureHighlight || inputtedEmail?.touched && inputtedEmail?.invalid)
            ? '!border-taxpod-red'
            : '!border'
        "
        pInputText
        formControlName="email"
        title="email"
        name="email"
        [attr.autocomplete]="autocompleteEnabled() ? 'username' : 'off'"
        (focus)="onAnyFieldFocus()"
      />

      @if (inputtedEmail?.touched && inputtedEmail?.invalid) {
      <div class="mt-[0px]">
        @if (inputtedEmail?.hasError('required')) {
        <p class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]">
          Email is required
        </p>
        } @if (inputtedEmail?.hasError('invalidEmailSyntax')) {
        <p class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]">
          Invalid email format
        </p>
        }
      </div>
      }
      
    </div>
   
    <div class="flex flex-col gap-2 mx-[12px] mt-[16px]">
      <label class="font-lato font-bold text-sm xlplus:text-base"
        >Password</label
      >
      <p-password
        formControlName="password"
        placeholder="Enter your password"
        [feedback]="false"
        [toggleMask]="true"
        [ngClass]="{
          'password-invalid': failureHighlight || (inputtedPassword?.touched && inputtedPassword?.invalid)
        }"
        inputStyleClass="!w-full !text-sm xlplus:!text-base placeholder:!text-sm xlplus:placeholder:!text-base placeholder:!text-gray-400"
        styleClass="!w-full placeholder-color"
        title="password"
        [autocomplete]="autocompleteEnabled() ? 'current-password' : 'off'"
        (onFocus)="onAnyFieldFocus()"
      >
      </p-password>

      @if (inputtedPassword?.touched && inputtedPassword?.invalid) {
      <div class="mt-[0px]">
        @if (inputtedPassword?.hasError('required')) {
        <p class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]">
          Password is required
        </p>
        }
      </div>
      }
    </div>
  </div>
  <div class="mt-[16px] mx-[12px]">
    <p-button
      type="submit"
      [loading]="isSubmitting"
      [disabled]="isButtonDisabled()"
      styleClass="!w-full !bg-taxpod-blue !border-taxpod-blue disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
      ><p class="font-lato text-sm xlplus:text-base">Login</p></p-button
    >
  </div>
</form>
<p
  routerLink="/auth/forgot-password"
  class="mt-[16px] mb-[12px] font-lato font-normal text-center text-xs xlplus:text-sm text-taxpod-blue cursor-pointer"
>
  Forgot Password
</p>
